import {ModalComponentProps, Block, Button, Card, Dialog, DialogBody, DialogFooter, VF} from '@mc/ui-v4';

import {Form} from 'react-final-form';
import React from 'react';
import {JsonImportCheckVO, JsonImportApi} from '../../../api';
import {actionApiCall} from '@mc/react-app-v4';

export const JSON_IMPORT_TITLE = 'Import JSON (POV)';

/**
 * Výběr JSON souboru pro import. Bez ID vrstvy se import provede do nově založené vrstvy,
 * s ID vrstvy do vrstvy existující.
 */
type Props = ModalComponentProps & {layerId?: number; onSubmit: (data: JsonImportCheckVO) => void};

export const UploadJsonModal: React.FC<Props> = ({onClose, onSubmit, layerId}) => {
    return (
        <Form onSubmit={onSubmit}>
            {({handleSubmit, submitting, form: {change}}) => {
                return (
                    <Dialog onClose={onClose} title={JSON_IMPORT_TITLE}>
                        <DialogBody>
                            <Card>
                                <Block>
                                    <VF.File
                                        label="JSON soubor"
                                        name="file"
                                        // @ts-ignore
                                        onUpload={async (file: File) =>
                                            await actionApiCall(async () => {
                                                const data = (await JsonImportApi.uploadJson(layerId, file)).data;
                                                change('layerId', data.layerId);
                                                change('filePath', data.filePath);
                                                change('layerName', data.layerName);
                                                change('recordCount', data.recordCount);
                                                change('newCount', data.newCount);
                                                change('updateCount', data.updateCount);
                                                change('recordsWithoutId', data.recordsWithoutId);
                                                change('recordsWithoutGeometry', data.recordsWithoutGeometry);
                                                change('duplicateIdCount', data.duplicateIdCount);
                                                change('canProceed', data.canProceed);
                                                handleSubmit();
                                            })
                                        }
                                    />
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                Pokračovat
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
